<template>
  <div>
    <!-- no-close-on-backdrop
      no-close-on-esc -->
    <b-modal
      ref="modal-monitoring-personal-attendance"
      :title="$t('PERSONAL ATTENDANCE')"
      modal-class="modal-primary"
      hide-footer
      @hidden="$emit('hideModal')"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      centered
      scrollable
    >
      <b-row>
        <b-col md="12" v-if="approved">
          <b-alert show variant="success" v-if="status_id == 2">
            <div class="alert-body">
              <feather-icon class="mr-25" icon="CheckCircleIcon" />
              <span class="ml-25"> {{ $t("Viatic Approved") }} </span>
            </div>
          </b-alert>
        </b-col>
        <b-col md="12" v-if="approved">
          <b-alert
            show
            variant="success"
            v-if="payroll_id != null && dataModal.origin == 'viatic'"
          >
            <div class="alert-body">
              <feather-icon class="mr-25" icon="CheckCircleIcon" />
              <span class="ml-25"> {{ $t("Payroll Generated") }} </span>
            </div>
          </b-alert>
        </b-col>
        <b-col md="12" v-if="isSoldDay">
          <b-alert show variant="warning">
            <div class="alert-body">
              <feather-icon class="mr-25" icon="AlertTriangleIcon" />
              <span class="ml-25">
                <strong>Aviso:</strong> Este día libre ha sido comprado por Recursos Humanos. Puedes registrar el tareo real (ej. Ruta, Local) del conductor con total normalidad; esto no afectará el pago de su día vendido.
              </span>
            </div>
          </b-alert>
        </b-col>
        <b-col sm="6">
          <b-input-group class="mb-1">
            <template #prepend>
              <b-input-group-text class="prepend__width">
                <strong> {{ $t("CODE") }} </strong>
              </b-input-group-text>
            </template>
            <b-form-input :value="dataModal.code" disabled />
          </b-input-group>
        </b-col>
        <b-col sm="6">
          <b-input-group class="mb-1">
            <template #prepend>
              <b-input-group-text class="prepend__width">
                <strong> {{ $t("NAME") }} </strong>
              </b-input-group-text>
            </template>
            <b-form-input :value="dataModal.personal_name" disabled />
          </b-input-group>
        </b-col>
      </b-row>

      <!-- <div class="scroll-kanban"> -->
      <ValidationObserver ref="ref-validation-personal-attendance">
        <b-row>
          <b-col
            v-if="
              isCeo ||
              isChief ||
              (currentUser.role_id == 4 && checkIfIsMonday()) ||
              (currentUser.role_id == 4 && dataModal.origin == 'viatic')
            "
            :sm="
              isCeo ||
              isChief ||
              (currentUser.role_id == 4 && checkIfIsMonday()) ||
              (currentUser.role_id == 4 && dataModal.origin == 'viatic')
                ? '6'
                : '12'
            "
          >
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              name="payment_date"
            >
              <b-form-group
                :label="$t('Date')"
                :state="errors[0] ? false : null"
              >
                <flat-pickr
                  v-model="form.attendance_date"
                  class="form-control"
                  :class="{ 'border-danger': errors[0] }"
                  :config="flatConfig"
                  :disabled="disabled"
                  @on-change="checkSoldDay"
                />
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col
            :sm="
              isCeo ||
              isChief ||
              (currentUser.role_id == 4 && checkIfIsMonday()) ||
              (currentUser.role_id == 4 && dataModal.origin == 'viatic')
                ? '6'
                : '12'
            "
          >
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              name="homework_status_id"
            >
              <b-form-group
                :label="$t('Homework Status')"
                :state="errors[0] ? false : null"
              >
                <v-select
                  v-model="form.homework_status_id"
                  :options="homeworkStatuses"
                  label="abbreviation"
                  :disabled="approved"
                  :reduce="(hs) => hs.id"
                />
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col
            :md="
              dataModal.origin == 'viatic' || dataModal.origin == 'payroll'
                ? '6'
                : '12'
            "
          >
            <ValidationProvider
              v-slot="{ errors }"
              rules="required|max:190"
              name="observation"
            >
              <b-form-group
                :label="$t('Observation')"
                :state="errors[0] ? false : null"
              >
                <b-form-textarea
                  v-model="form.observation"
                  rows="3"
                  :class="{ 'border-danger': errors[0] }"
                  :disabled="approved"
                />
                <span v-if="errors[0]" class="text-danger">
                  Observacion
                  {{
                    errors[0] == "is max"
                      ? " es maximo 190 caracteres"
                      : errors[0]
                  }}</span
                >
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col
            md="6"
            v-if="dataModal.origin == 'viatic' || dataModal.origin == 'payroll'"
          >
            <ValidationProvider
              v-slot="{ errors }"
              rules="max:190"
              name="comment"
            >
              <b-form-group
                :label="$t('Comment')"
                :state="errors[0] ? false : null"
              >
                <b-form-textarea
                  v-model="form.comment"
                  rows="3"
                  :class="{ 'border-danger': errors[0] }"
                />
                <span v-if="errors[0]" class="text-danger">
                  Observacion
                  {{
                    errors[0] == "is max"
                      ? " es maximo 190 caracteres"
                      : errors[0]
                  }}</span
                >
              </b-form-group>
            </ValidationProvider>
          </b-col>
        </b-row>
      </ValidationObserver>
      <!-- </div> -->
      <div class="text-right">
        <b-button
          v-if="!approved"
          @click="savePersonalAttendance"
          variant="outline-success"
          >{{ $t("Save") }}</b-button
        >
        <b-button
          v-if="approved"
          variant="outline-success"
          @click="saveComment"
          >{{ $t("Save Comment") }}</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import { mapGetters } from "vuex";
import modalMixin from "@/mixins/modal";
import AttendanceService from "@/views/monitoring/views/attendance/services/attendance.service.js";
import ViaticService from "@/views/monitoring/views/viatic/services/viatic.service.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import DaysService from "@/views/users/views/list/services/days.service.js";

export default {
  mixins: [modalMixin],
  components: {
    flatPickr,
  },
  props: {
    dataModal: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      homeworkStatuses: [],
      form: {
        attendance_id: this.dataModal.id,
        user_id: null,
        homework_status_id: null,
        observation: null,
        comment: null,
        attendance_date: null,
        is_viatic: 1,
        status: 1,
      },
      disabled: false,
      approved: false,
      status_id: null,
      payroll_id: null,
      isSoldDay: false,
      flatConfig: {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        enable: [],
      },
    };
  },
  mounted() {
    this.toggleModal("modal-monitoring-personal-attendance");
  },
  async created() {
    this.getHomeworkDays();
    if (
      this.dataModal.origin == "viatic" ||
      this.dataModal.origin == "payroll"
    ) {
      this.form.attendance_date = this.dataModal.date;
      this.form.homework_status_id = this.dataModal.homework_status_id;
      this.form.observation = this.dataModal.observation;
      this.form.comment =
        this.dataModal.comment == "null" ? null : this.dataModal.comment;
      this.disabled = true;
      this.approved = this.dataModal.approved;
      this.status_id = this.dataModal.attendance_status_viatic_id;
      this.payroll_id = this.dataModal.payroll_id;
      this.checkSoldDay(null, this.form.attendance_date, null);
    }
    await this.getHomeworkStatuses();
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  methods: {
    async getHomeworkStatuses() {
      try {
        this.addPreloader();
        const { data } = await AttendanceService.getSelectHomeworkStatuses();
        this.homeworkStatuses = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async checkSoldDay(selectedDates, dateStr, instance) {
      if (!dateStr) {
        this.isSoldDay = false;
        return;
      }
      try {
        const params = {
          date: dateStr,
          attendance_id: this.form.attendance_id,
        };
        const { data } = await ViaticService.validateApprovedAttendance(params);
        this.isSoldDay = data.is_sold || false;
      } catch (error) {
        console.log(error);
      }
    },
    getHomeworkDays() {
      if (this.checkIfIsMonday() && this.currentUser.role_id == 4) {
        let lastWeek = this.getDaysOfWeek([1, 7]);
        this.flatConfig = {
          enableTime: true,
          dateFormat: "Y-m-d H:i",
          enable: lastWeek,
        };
        return;
      }

      this.flatConfig = {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
      };
    },
    checkIfIsMonday() {
      return moment().isoWeekday() === 1;
    },
    getDaysOfWeek(daysNumber) {
      let formattedDates = daysNumber.map((day) => {
        if (day === 7) {
          return moment().day(day).subtract(7, "days").format("YYYY-MM-DD");
        } else {
          return moment().day(day).format("YYYY-MM-DD");
        }
      });
      return formattedDates;
    },
    async saveComment() {
      try {
        const confirm = await this.showConfirmSwal();
        if (confirm.isConfirmed) {
          this.addPreloader();
          const params = {
            id: this.dataModal.id_detail,
            comment: this.form.comment,
          };
          const { data } = await AttendanceService.saveComment(params);
          this.$toast({
            component: ToastificationContent,
            position: "top-center",
            props: {
              title: this.$t("Success"),
              icon: "CoffeeIcon",
              variant: "success",
              text: this.$t("Comment inserted successfully"),
            },
          });
          this.$emit("hideModal", true);
          this.$emit("refreshPayroll");
        }
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          position: "top-center",
          props: {
            title: "Error",
            icon: "CoffeeIcon",
            variant: "danger",
            text: this.$t("Error in transaction"),
          },
        });
      } finally {
        this.removePreloader();
      }
    },
    async savePersonalAttendance() {
      try {
        const isValidate = await this.$refs[
          "ref-validation-personal-attendance"
        ].validate();
        if (isValidate) {
          this.addPreloader();
          this.form.user_id = this.currentUser.id;
          const params = {
            date: this.form.attendance_date,
            attendance_id: this.form.attendance_id,
          };
          const dataValidate = await ViaticService.validateApprovedAttendance(
            params
          );
          if (dataValidate.data.isApproved == false) {
            this.form.origin = this.dataModal.origin;
            this.form.payroll_id = this.dataModal.payroll_id || null;
            const { data } = await AttendanceService.savePersonalAttendance(
              this.form
            );
            if (this.dataModal.origin == "payroll") {
              this.$emit("refreshPayroll");
            }
            this.$emit("hideModal", true);
          } else {
            this.$toast({
              component: ToastificationContent,
              position: "top-center",
              props: {
                title: "Warning",
                icon: "CoffeeIcon",
                variant: "warning",
                text: "Attendance already approved.",
              },
            });
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>